<template>
  <v-dialog
    v-model="_active"
    @click:outside="_setActive(false)"
    :width="dialogStyle"
    id="recon-export-dialog"
  >
    <v-card v-if="phase === 'preExport'" style="overflow:hidden;">
      <v-card-title>
        <v-card-text class="text-subtitle-1 font-weight-medium pb-0">
          MISSING ACCESSORIES
        </v-card-text>
      </v-card-title>
      <v-divider />
      <div class="ml-6 mr-2 my-2">
        <v-row align="center" id="device-id">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Device ID
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox hide-details v-model="device_id" dense class="mt-n1" />
          </v-col>
        </v-row>
        <!-- <v-row align="center" id="accessory-name">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Accessory Name
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox
              hide-details
              dense
              v-model="accessory_name"
              class="mt-n1"
            />
          </v-col>
        </v-row> -->
        <!-- <v-row align="center" id="accessory-status">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Accessory Status
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox
              hide-details
              dense
              v-model="accessory_status"
              class="mt-n1"
            />
          </v-col>
        </v-row> -->
        <v-row align="center" id="ra">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              RA #
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox hide-details dense v-model="ra_number" class="mt-n1" />
          </v-col>
        </v-row>
        <v-row align="center" id="trip-type">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Trip Type
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox hide-details dense v-model="trip_type" class="mt-n1" />
          </v-col>
        </v-row>
        <v-row align="center" id="start-date">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Rental Start Date
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox
              hide-details
              dense
              v-model="rental_start_date"
              class="mt-n1"
            />
          </v-col>
        </v-row>
        <v-row align="center" id="due-date">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Expected Due Date
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox
              hide-details
              dense
              v-model="expected_due_date"
              class="mt-n1"
            />
          </v-col>
        </v-row>
        <!-- <v-row align="center" id="recon-by">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Reconciled By
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox
              hide-details
              dense
              v-model="reconciled_by"
              class="mt-n1"
            />
          </v-col>
        </v-row> -->
      </div>
      <v-divider />
      <v-card-title id="export-type">
        <v-card-text class="text-subtitle-1 font-weight-medium pb-0">
          EXPORT TYPE
        </v-card-text>
      </v-card-title>
      <v-divider />
      <div class="ml-6 mr-2 my-2">
        <v-row align="center" id="export-type-csv">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              CSV
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox hide-details dense v-model="csv" class="mt-n1" />
          </v-col>
        </v-row>
        <v-row align="center" id="export-type-excel">
          <v-col cols="11" class="py-1">
            <v-card-text class="py-0">
              Excel Document
            </v-card-text>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-checkbox hide-details dense v-model="excel" class="mt-n1" />
          </v-col>
        </v-row>
      </div>
      <v-divider />
      <v-row>
        <v-spacer />
        <v-btn
          class="white--text ma-3"
          color="secondary"
          :disabled="disableExport"
          @click="exportReport()"
          :width="180"
          id="export-dialog-button"
        >
          <v-icon x-small>mdi-download</v-icon>
          Export
        </v-btn>
        <v-btn
          class="ma-3"
          @click="_setActive(false)"
          :width="180"
          id="cancel-dialog-button"
        >
          Cancel
        </v-btn>
        <v-spacer />
      </v-row>
    </v-card>
    <div v-if="phase === 'loading'" id="loading">
      <loading />
    </div>
    <v-card height="300" v-if="phase === 'exported'" id="exported">
      <div class="d-flex">
        <v-card-text class="text-h4 pt-7 pl-8">
          Your download is ready
        </v-card-text>
        <v-btn class="ma-8" @click="_setActive(false)">
          <v-icon>
            mdi-close
          </v-icon>
          Close
        </v-btn>
      </div>
      <div class="d-flex">
        <a :href="_exportURL.csv" v-if="csv === true">
          <v-card-text class="text-h6 px-8">
            CSV
          </v-card-text>
        </a>
        <a :href="_exportURL.excel" v-if="excel === true">
          <v-card-text class="text-h6 px-8">
            Excel
          </v-card-text>
        </a>
      </div>
      <div class="d-flex justify-center">
        <v-btn
          color="secondary"
          width="170"
          tile
          class="mt-14 ml-7 white--text"
          @click="phase = 'preExport'"
          id="export-again-button"
        >
          <v-icon>mdi-download</v-icon>
          EXPORT AGAIN
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import Loading from '@/components/export/Loading';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      phase: 'preExport',
      csv: true,
      excel: true,
      device_id: true,
      accessory_name: true,
      accessory_status: true,
      ra_number: true,
      trip_type: true,
      rental_start_date: true,
      expected_due_date: true,
      reconciled_by: true,
    };
  },
  methods: {
    ...mapMutations({
      _setActive: 'reconciliation/setExport',
    }),
    ...mapActions({
      _exportReport: 'reconciliation/exportReport',
    }),
    exportReport() {
      this.phase = 'loading';
      this._exportReport(this.payload);
    },
  },
  computed: {
    ...mapGetters({
      _active: 'reconciliation/getExport',
      _exportURL: 'reconciliation/getExportURL',
    }),
    dialogStyle() {
      if (this.showMobileView) {
        return '';
      }
      return '50%';
    },
    payload() {
      return {
        csv: this.csv,
        excel: this.excel,
        device_id: this.device_id,
        accessory_name: this.accessory_name,
        accessory_status: this.accessory_status,
        ra_number: this.ra_number,
        trip_type: this.trip_type,
        rental_start_date: this.rental_start_date,
        expected_due_date: this.expected_due_date,
        reconciled_by: this.reconciled_by,
      };
    },
    disableExport() {
      if (
        (this.csv || this.excel)
        && (this.device_id
          || this.accessory_name
          || this.accessory_status
          || this.ra_number
          || this.trip_type
          || this.rental_start_date
          || this.expected_due_date
          || this.reconciled_by)
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    _exportURL: {
      handler() {
        if (this._exportURL.loaded) {
          this.phase = 'exported';
        }
      },
      deep: true,
    },
  },
};
</script>
